import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import styled from "styled-components";
import SYPrimaryButton from "../../../components/SYPrimaryButton";
import Title from "../../../components/Title";
import {
  CSS_BREAKPOINTS_MIN,
  GREY_03_COLOR,
  GUTTER_SIZE,
  MAIN_ORANGE_LIGHT_COLOR,
  PAGE_PADDING_LEFT_RIGHT,
  PAPER_WHITE_COLOR,
  PRIMARY_COLOR,
  SPACING_BASE,
} from "../../../config/constants";
import { ReactComponent as NextSvg } from "../../../assets/svg/ic_next.svg";
import { useEffect, useState } from "react";
import { bindActionCreators } from "redux";
import * as planActionCreators from "../../../store/actions/plan";
import urls from "../../../config/urls";
import UserUtils from "../../../utils/user.utils";
import { PageNotFound } from "../../../pages";
import { isEmpty } from "lodash";
import LoadingAnimation from "../../../components/LoadingAnimation";
import * as masterCourseActionCreators from "../../../store/actions/masterCourse";
import usePlanInfo from "../../../customHooks/userPlanInfo";
import _get from 'lodash/get';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: ${GUTTER_SIZE * 2}px 0;

  @media ${CSS_BREAKPOINTS_MIN.sm} {
    padding-left: ${SPACING_BASE * 3}px;
    padding-right: ${SPACING_BASE * 3}px;
  }

  @media ${CSS_BREAKPOINTS_MIN.md} {
    width: 100%;
    padding: 0 ${SPACING_BASE * 3}px;
  }

  @media ${CSS_BREAKPOINTS_MIN.lg} {
    padding: 0 ${PAGE_PADDING_LEFT_RIGHT}px;
  }
`;

const CardBackground = styled.div`
  display: flex;
  flex-direction: column;
  background: ${GREY_03_COLOR};
  padding: 24px 20px 32px 20px;
  margin: 20px;
`;

const CTA = styled(SYPrimaryButton)`
  width: 100%;

  @media ${CSS_BREAKPOINTS_MIN.sm} {
    max-width: 320px;
    align-self: center;
  }
`;

const CTAContainer = styled.div`
  display: flex;
  flex-direction: column;

  @media ${CSS_BREAKPOINTS_MIN.sm} {
    width: auto;
    min-width: 320px;
    display: flex;
  }

  @media ${CSS_BREAKPOINTS_MIN.md} {
    width: auto;
    display: inline-flex;
  }
`;

const ChangeLaterView = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height: 70px;
  cursor: pointer;

  :hover h1 {
    color: ${MAIN_ORANGE_LIGHT_COLOR};
    transition: 0.2s;
  }

  @media ${CSS_BREAKPOINTS_MIN.sm} {
    width: auto;
    max-width: 320px;
    display: flex;
    align-self: center;
  }

  @media ${CSS_BREAKPOINTS_MIN.md} {
    width: auto;
    display: inline-flex;
  }
`;

const SwitchModalView = (props) => {
  const { user, planActions, masterCourses, masterCoursesActions, activePlan} = props;
  const isFromRegularTrainingHome = props?.location?.state?.isFromRegularTrainingHome;
  const [isFetching, setFetching] = useState(false);
  const [workoutSlug, setWorkoutSlug] = useState( props?.location?.state?.courseSlug);
  const [redirect, setRedirect] = useState("");

  useEffect(() => {
    if (isEmpty(masterCourses)) {
      masterCoursesActions.fetchMasterCourses();
    }
  }, [masterCourses, masterCoursesActions]);

  const targetPlanUid = _get(props, 'location.state.courseSlug');
  const { planInfo } = usePlanInfo(props?.activePlan);
  console.log('planInfo', planInfo);

  let course = null;
  if (targetPlanUid) {
    course = masterCourses.find(
      (item) => item.programData.externalContentSlug === targetPlanUid
    );
  } else if (!!planInfo?.uid) {
    course = masterCourses.find(
      (item) => item.programData.externalContentSlug !== planInfo.uid
    )
  } else {
    course = masterCourses.find(
      (item) => item.programData.externalContentSlug !== props?.courseSlug
    );
  }

  useEffect(() => {
    window.scrollTo(0, 0);
    if (!!redirect && !!workoutSlug) {
      if (redirect === urls.MASTER_CLASS_WORKOUT_DETAIL) {
        if (!!isFromRegularTrainingHome) {
          props.history.replace(urls.TRAINING);
        } else {
          props.history.push(
            urls.COURSE_DETAIL_FTUE.replace(":slug", course?.programData?.externalContentSlug),
          );
        }
      } else if (redirect === urls.COURSE_COMPLETION) {
        props.history.push(urls.COURSE_COMPLETION);
      }
    } else if (!course?.programData?.externalContentSlug) {
      if (!!isFromRegularTrainingHome) {
        props.history.replace(urls.TRAINING);
      } else {
        props.history.replace(urls.TRAINING_HOME);
      }
    }
  }, [redirect, workoutSlug, isFromRegularTrainingHome, course?.programData?.externalContentSlug]);

  const onChangePriorityCourseClick = async () => {
    console.log({ masterCourses });
    const matchItem = masterCourses.find(
      (item) => item.programData.externalContentSlug === course?.programData?.externalContentSlug
    );
    console.log("matchItem: ", matchItem);
    if (!!matchItem) {
      setFetching(true);

      const response = await planActions.checkAccessiblePlan({
        programId: matchItem.programData.id,
      });
      const itemNextWorkoutSlug = response?.accessibility?.find(
        (item) => item.done === 0
      );
      const nextWorkoutSlug = itemNextWorkoutSlug?.workoutInfo?.externalContentSlug;
      console.log("nextWorkoutSlug: ", nextWorkoutSlug);
      setWorkoutSlug(nextWorkoutSlug);
      console.log("response: ", response);
      if (!!nextWorkoutSlug) {
        if (!!itemNextWorkoutSlug) {
          if (!!itemNextWorkoutSlug?.canAccess) {
            const slug = course?.programData?.externalContentSlug;
            await planActions.fetchActivePlanBySlug({
              userId: user.id,
              slug: slug,
            });
            await planActions.fetchActivePlan(user.id);
            setRedirect(urls.MASTER_CLASS_WORKOUT_DETAIL);
          } else {
            console.log("navigate paywall ======= ");
            props.history.push(urls.PAYWALL.replace(":slug", course?.programData?.externalContentSlug));
          }
        } else {
          setRedirect(urls.COURSE_COMPLETION);
        }
      } else {
        props.history.push(urls.TRAINING_HOME);
      }
    }
  };

  const onChangeLaterClick = () => {
    const fromCourseDetailFTUE = props?.location?.state?.fromCourseDetailFTUE;
    const courseSlug = props?.location?.state?.courseSlug;
    if (!!fromCourseDetailFTUE) {
      const isActiveOldCourse = activePlan?.planData?.externalContentSlug?.length === 0
      if (isActiveOldCourse) {
        props.history.replace(urls.TRAINING);
      } else {
        props.history.replace(urls.COURSE_DETAIL_FTUE.replace(":slug", courseSlug), {
          isFromRegularTrainingHome: isFromRegularTrainingHome,
          backFromSwitchModalView: true
        });
      }
    } else if (!!isFromRegularTrainingHome) {
      props.history.replace(urls.TRAINING);
    } else {
      props.history.replace(urls.RECOMMENDATION);
    }
  };

  if (!course) {
    return <LoadingAnimation />;
  }

  return (
    <Container>
      <CardBackground>
        <Title
          fontsize={"20px"}
          marginTop={"16px"}
          lineHeight={"25px"}
          letterSpacing={"0.4px"}
          color={PAPER_WHITE_COLOR}
          fontWeight={"500"}
          textAlign={"center"}
        >
          {`Want to make this Master Course your priority?`}
        </Title>
        <Title
          fontsize={"15px"}
          marginTop={"20px"}
          marginLeft={"20px"}
          marginRight={"20px"}
          lineHeight={"26px"}
          letterSpacing={"0.08px"}
          fontWeight={"300"}
          textAlign={"center"}
        >
          {`Do you want to put your focus on the  Master Course ${
            course?.programData?.name
          }
          ${UserUtils.getDataMasterCourse(
            planInfo?.data,
            "title[0].text"
          ) ? `instead of the ${UserUtils.getDataMasterCourse(
            planInfo?.data,
            "title[0].text"
          )}?`: '?'}`}
        </Title>
        <Title
          fontsize={"15px"}
          marginLeft={"20px"}
          marginRight={"20px"}
          marginBottom={"25px"}
          lineHeight={"26px"}
          letterSpacing={"0.08px"}
          fontWeight={"300"}
          textAlign={"center"}
        >
          You can change this later.
        </Title>

        <CTAContainer>
          <CTA
            disabled={isFetching}
            title={isFetching ? "Checking..." : "MAKE THIS MY PRIORITY"}
            onClick={onChangePriorityCourseClick}
          />
          <ChangeLaterView onClick={onChangeLaterClick}>
            <Title
              fontsize={"14px"}
              lineHeight={"21px"}
              marginTop={"0px"}
              marginRight={"10px"}
              letterSpacing={"1.12px"}
              fontWeight={"400"}
              color={PRIMARY_COLOR}
            >
              Change later
            </Title>
            <NextSvg />
          </ChangeLaterView>
        </CTAContainer>
      </CardBackground>
    </Container>
  );
};

const mapStateToProps = ({ masterCourses, auth, activePlan }) => ({
  masterCourses,
  activePlan,
  user: auth.user,
});

const mapDispatchToProps = (dispatch) => ({
  planActions: bindActionCreators(planActionCreators, dispatch),
  masterCoursesActions: bindActionCreators(masterCourseActionCreators, dispatch),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(SwitchModalView)
);
